<template>
  <div class="dev">
    <h1>{{ $t('dev.interface') }}</h1>

    <div class="section">
      <div class="icons">
        <img v-for="(icon, idx) in icons" :key="idx" :src="icon" alt="ico dev" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Interface',
  components: {},
  data() {
    return {
      icons: [
        require('@/assets/icons/apply.svg'),
        require('@/assets/icons/arrow-dropdown.svg'),
        require('@/assets/icons/arrow-r-dark.svg'),
        require('@/assets/icons/arrow-r-white.svg'),
        require('@/assets/icons/arrow-r.svg'),
        require('@/assets/icons/arrow.svg'),
        require('@/assets/icons/attachment.svg'),
        require('@/assets/icons/attendee.svg'),
        require('@/assets/icons/back-mini.svg'),
        require('@/assets/icons/back.svg'),
        require('@/assets/icons/chat-attendees.svg'),
        require('@/assets/icons/chat-back.svg'),
        require('@/assets/icons/chat-group.svg'),
        require('@/assets/icons/chat-message.svg'),
        require('@/assets/icons/chat-more-dots-horizontal.svg'),
        require('@/assets/icons/chat-more-dots.svg'),
        require('@/assets/icons/chat-search.svg'),
        require('@/assets/icons/chat-submit.svg'),
        require('@/assets/icons/checkbox-arrow.svg'),
        require('@/assets/icons/checkbox-w.svg'),
        require('@/assets/icons/clock.svg'),
        require('@/assets/icons/close-dark.svg'),
        require('@/assets/icons/close.svg'),
        require('@/assets/icons/edit-dark.svg'),
        require('@/assets/icons/edit.svg'),
        require('@/assets/icons/expert-b.svg'),
        require('@/assets/icons/file-primary.svg'),
        require('@/assets/icons/filter.svg'),
        require('@/assets/icons/log-out.svg'),
        require('@/assets/icons/meeting-dark.svg'),
        require('@/assets/icons/menu.svg'),
        require('@/assets/icons/message.svg'),
        require('@/assets/icons/notify.svg'),
        require('@/assets/icons/paginator-l.svg'),
        require('@/assets/icons/paginator-r.svg'),
        require('@/assets/icons/paper-clip.svg'),
        require('@/assets/icons/pause.svg'),
        require('@/assets/icons/play-white.svg'),
        require('@/assets/icons/play.svg'),
        require('@/assets/icons/plus-dark.svg'),
        require('@/assets/icons/plus.svg'),
        require('@/assets/icons/search.svg'),
        require('@/assets/icons/smile.svg'),
        require('@/assets/icons/star-fill.svg'),
        require('@/assets/icons/star.svg'),
        require('@/assets/icons/timeline-indicator.svg'),
        require('@/assets/icons/upload.svg'),
        require('@/assets/icons/polls-progress.svg'),
        require('@/assets/icons/caret.svg'),
        require('@/assets/icons/checkbox.svg'),
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.dev {
  margin: 100px 0;
}

.section {
  margin: 32px 0;
}

.icons {
  display: flex;
  flex-wrap: wrap;
  background: rgba(black, 0.05);
  img,
  svg {
    height: 32px;
    margin: 8px;
  }
}
</style>
